import { render, staticRenderFns } from "./deals-offers.vue?vue&type=template&id=5a63533b&"
import script from "./deals-offers.vue?vue&type=script&lang=js&"
export * from "./deals-offers.vue?vue&type=script&lang=js&"
import style0 from "./deals-offers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports